import {
  NavLink as BSNavLink,
  Collapse,
  Nav,
  NavItem,
  Navbar,
} from 'reactstrap';
import {
  MdAttachMoney,
  MdKeyboardArrowDown,
  MdPerson,
  MdPlace,
  MdShoppingCart,
  MdWallpaper,
  MdViewList,
  MdStoreMallDirectory,
  MdImage,
  MdPayment,
  MdLocalShipping,
  MdDashboard,
  MdMoveToInbox,
  MdStyle,
  MdExitToApp,
  MdCardGiftcard,
  MdCancel,
  MdLanguage,
  MdMessage,
  MdChromeReaderMode,
  MdNotificationsNone,
  MdSettings,
  MdAccountBalanceWallet,
  MdContacts,
  MdFilter,
  MdMenu,
  MdSend,
} from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import React, { Fragment } from 'react';
import cx from 'classnames';

import SourceLink from 'components/SourceLink';
import bn from 'utils/bemnames';
import { AuthConsumerHOC } from 'src/authentication/AuthContext';

import promptPlusLogo from '../assets/images/new-promptplus-logo.png';
import { isUndefined } from 'lodash';
import { FeatureFlags } from '@scg/types/dist';

const bem = bn.create('sidebar');

class Sidebar extends React.Component {
  state = {
    activeCollapsables: [],
    featureFlags: this.props.auth.featureFlags,
  };

  findFeatureFlagByCode = (code) => {
    return this.state.featureFlags[code];
  };

  onClickCollapseable = (name) => {
    const collapseableIndex = this.state.activeCollapsables.indexOf(name);

    if (collapseableIndex > -1) {
      const newActiveCollapables = [...this.state.activeCollapsables];
      newActiveCollapables.splice(collapseableIndex, 1);
      this.setState({
        activeCollapsables: newActiveCollapables,
      });
      return;
    }

    this.setState({
      activeCollapsables: [...this.state.activeCollapsables, name],
    });
  };

  renderNavItem = ({ to, name, exact, Icon, links = [] }) => {
    if (to) {
      return (
        <NavItem key={name} className={bem.e('nav-item')}>
          <BSNavLink
            id={`navItem-${name}`}
            className="text-uppercase"
            tag={NavLink}
            to={to}
            activeClassName="active"
            exact={exact}
          >
            <Icon className={bem.e('nav-item-icon')} />
            <span className="">{name}</span>
          </BSNavLink>
        </NavItem>
      );
    }

    const isOpen = this.state.activeCollapsables.includes(name);

    return (
      <Fragment key={name}>
        <NavItem
          className={bem.e('nav-item')}
          onClick={() => this.onClickCollapseable(name)}
        >
          <BSNavLink
            className={cx(bem.e('nav-item-collapse', 'text-uppercase'))}
          >
            <div className="d-flex">
              <Icon className={bem.e('nav-item-icon')} />
              <span className="align-self-start">{name}</span>
            </div>
            <MdKeyboardArrowDown
              className={bem.e('nav-item-icon')}
              style={{
                padding: 0,
                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                transitionDuration: '0.3s',
                transitionProperty: 'transform',
              }}
            />
          </BSNavLink>
        </NavItem>

        <Collapse isOpen={isOpen}>
          {links
            .filter(({ featureCode }) => {
              const featureFlagEnabled =
                this.findFeatureFlagByCode(featureCode);
              // Default visible true
              if (isUndefined(featureFlagEnabled)) {
                return true;
              }
              return featureFlagEnabled;
            })
            .map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
        </Collapse>
      </Fragment>
    );
  };

  signout = async () => {
    await this.props.auth.signout();
  };

  render() {
    return (
      <aside className={bem.b('cr-sidebar--open')}>
        <div className={bem.e('background')} />
        <div className={bem.e('content')}>
          <Navbar style={{ background: 'white' }}>
            <SourceLink className="navbar-brand d-flex">
              <img src={promptPlusLogo} height="40" className="pr-2" alt="" />
            </SourceLink>
          </Navbar>

          <Nav vertical>
            {[
              {
                to: '/',
                name: 'dashboard',
                exact: true,
                Icon: MdDashboard,
              },

              { to: '/admins', name: 'admins', exact: true, Icon: MdPerson },
              { to: '/sales', name: 'sales', exact: true, Icon: MdPerson },
              { to: '/dealers', name: 'dealers', exact: true, Icon: MdPerson },
              {
                to: '/sub-dealers',
                name: 'sub-dealers',
                exact: true,
                Icon: MdPerson,
              },
              {
                to: '/products',
                name: 'products',
                exact: true,
                Icon: MdShoppingCart,
              },
              {
                to: '/productDealer',
                name: 'product-dealer-relations',
                exact: true,
                Icon: MdShoppingCart,
              },
              {
                to: '/product-dealer-interfaces',
                name: 'product-dealer-interfaces',
                exact: true,
                Icon: MdShoppingCart,
              },
              {
                to: '/prices',
                name: 'prices',
                exact: true,
                Icon: MdAttachMoney,
              },
              {
                to: '/product-categories',
                name: 'Categories',
                exact: true,
                Icon: MdViewList,
              },
              {
                to: '/segments',
                name: 'Segments',
                exact: true,
                Icon: MdViewList,
              },
              {
                to: '/product-groups',
                name: 'Groups',
                exact: true,
                Icon: MdViewList,
              },
              { to: '/shelf', name: 'Shelf', exact: true, Icon: MdViewList },
              {
                to: '/fixed-shelf',
                name: 'Fixed Shelf',
                exact: true,
                Icon: MdViewList,
              },
              { to: '/brands', name: 'Brand', exact: true, Icon: MdViewList },
              {
                to: '/competitor-products',
                name: 'Competitor Products',
                exact: true,
                Icon: MdShoppingCart,
              },
              {
                to: '/promotions',
                name: 'promotions',
                exact: true,
                Icon: MdCardGiftcard,
              },
              {
                to: '/bundles',
                name: 'bundles',
                exact: true,
                Icon: MdCardGiftcard,
              },
              {
                to: '/banners',
                name: 'banners',
                exact: true,
                Icon: MdWallpaper,
              },
              {
                to: '/orders',
                name: 'orders',
                exact: true,
                Icon: MdPayment,
              },
              {
                to: '/quotations',
                name: 'quotations',
                exact: true,
                Icon: MdPayment,
              },
              {
                to: '/home-menus',
                name: 'home-menus',
                exact: true,
                Icon: MdViewList,
              },
              {
                to: '/image-popup',
                name: 'image-popup',
                exact: true,
                Icon: MdImage,
              },
              {
                to: '/floating-button',
                name: 'floating-button',
                exact: true,
                Icon: MdFilter,
              },
              {
                name: 'Master',
                Icon: MdPerson,
                links: [
                  {
                    to: '/plants',
                    name: 'plants',
                    exact: true,
                    Icon: MdStoreMallDirectory,
                  },
                  {
                    to: '/payment-methods',
                    name: 'payment-methods',
                    exact: true,
                    Icon: MdPayment,
                  },
                  {
                    to: '/transportations',
                    name: 'transportations',
                    exact: true,
                    Icon: MdLocalShipping,
                  },
                  {
                    to: '/sale-order-ship-codes',
                    name: 'Sale Order Ship Codes',
                    exact: true,
                    Icon: MdLocalShipping,
                  },
                  {
                    to: '/reject-reasons',
                    name: 'reject reason',
                    exact: true,
                    Icon: MdCancel,
                  },
                  { to: '/images', name: 'images', exact: true, Icon: MdImage },
                  {
                    to: '/localization',
                    name: 'localization',
                    exact: true,
                    Icon: MdLanguage,
                  },
                  {
                    to: '/feature-flag',
                    name: 'Feature Flag',
                    exact: true,
                    Icon: MdLanguage,
                  },
                  {
                    to: '/master-bank',
                    name: 'Master Bank',
                    exact: true,
                    Icon: MdAccountBalanceWallet,
                  },
                  {
                    to: '/use-for',
                    name: 'use-for',
                    exact: true,
                    Icon: MdMenu,
                  },
                  {
                    to: '/auto-email',
                    name: 'auto-email',
                    exact: true,
                    Icon: MdSend,
                  },
                ],
              },
              {
                name: 'Line Message',
                Icon: MdMessage,
                links: [
                  {
                    to: '/line-template',
                    name: 'Line Template',
                    exact: true,
                    Icon: MdChromeReaderMode,
                  },
                  {
                    to: '/line-template-config',
                    name: 'Line Template Config',
                    exact: true,
                    Icon: MdSettings,
                  },
                  {
                    to: '/line-consolidate-logs',
                    name: 'Line Conversation Logs',
                    exact: true,
                    Icon: MdMessage,
                  },
                ],
              },
              {
                name: 'Address',
                Icon: MdPlace,
                links: [
                  {
                    to: '/regions',
                    name: 'regions',
                    exact: true,
                    Icon: MdPlace,
                  },
                  {
                    to: '/provinces',
                    name: 'provinces',
                    exact: true,
                    Icon: MdPlace,
                  },
                  {
                    to: '/districts',
                    name: 'districts',
                    exact: true,
                    Icon: MdPlace,
                  },
                  {
                    to: '/subdistricts',
                    name: 'subdistricts',
                    exact: true,
                    Icon: MdPlace,
                  },
                  {
                    to: '/postal-codes',
                    name: 'postal-codes',
                    exact: true,
                    Icon: MdPlace,
                  },
                ],
              },
              {
                name: 'Bulk Upload',
                Icon: MdMoveToInbox,
                links: [
                  {
                    to: '/bulk-upload/productChangFamilyReward',
                    name: 'product chang family',
                    exact: true,
                    Icon: MdStoreMallDirectory,
                  },
                  {
                    to: '/bulk-upload/productETA',
                    name: 'product ETA',
                    exact: true,
                    Icon: MdStyle,
                    featureCode: FeatureFlags.productETA.code,
                  },
                  {
                    to: '/bulk-upload/productETACustom',
                    name: 'product ETA custom',
                    exact: true,
                    Icon: MdStyle,
                    featureCode: FeatureFlags.productETACustom.code,
                  },
                  {
                    to: '/bulk-upload/productETASpecialDistrict',
                    name: 'product ETA special district',
                    exact: true,
                    Icon: MdStyle,
                    featureCode: FeatureFlags.productETASpecialDistrict.code,
                  },
                  {
                    to: '/bulk-upload/productSML',
                    name: 'product SML',
                    exact: true,
                    Icon: MdShoppingCart,
                    featureCode: FeatureFlags.productSML.code,
                  },
                  {
                    to: '/bulk-upload/plant',
                    name: 'plant',
                    exact: true,
                    Icon: MdStoreMallDirectory,
                  },
                  {
                    to: '/bulk-upload/forwardingAgent',
                    name: 'Forwarding agent',
                    exact: true,
                    Icon: MdContacts,
                  },
                  {
                    to: '/bulk-upload/competitorProduct',
                    name: 'Competitor Products',
                    exact: true,
                    Icon: MdShoppingCart,
                  },
                ],
              },

              // {
              //   to: '/product-units',
              //   name: 'Product Units',
              //   exact: true,
              //   Icon: MdAcUnit,
              // },
              // {
              //   to: '/units',
              //   name: 'Units',
              //   exact: true,
              //   Icon: MdAcUnit,
              // },
              {
                to: '/notifications',
                name: 'Notifications',
                exact: true,
                Icon: MdNotificationsNone,
              },
            ].map(this.renderNavItem)}
            <li className="cr-sidebar__nav-item nav-item">
              <a className="text-uppercase nav-link" onClick={this.signout}>
                <MdExitToApp className="cr-sidebar__nav-item-icon" />
                <span className="">Sign Out</span>
              </a>
            </li>
          </Nav>
        </div>
      </aside>
    );
  }
}

export default AuthConsumerHOC(Sidebar);
